import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, responsiveText, spacing } = theme;

export const listingsHeaderRoot = css`
  grid-column: span 12;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: -${spacing.base}px 0;
  padding: ${spacing.sm}px ${spacing.md}px;
  background-color: rgba(248, 248, 255, 0.7);
  backdrop-filter: blur(4px);
  z-index: 2;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: -${spacing.base}px -${spacing.md}px;
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: none;
    `,
  )};
`;

export const totalProducts = css`
  margin: 0;
  ${responsiveText.BODY.SM};
  color: var(--brand-bluple-base);
`;

export const listingsHeaderButton = css`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  background-color: var(--brand-bluple-base);
  border-radius: 6px;
  border: none;
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveText.BODY.MD};
  white-space: nowrap;
  color: var(--neutral-white-base);
  padding: ${spacing.xs}px;
  cursor: pointer;
`;

export const iconFilter = css`
  margin-left: ${spacing.xs}px;
  width: ${spacing.md}px;
  height: ${spacing.md}px;
`;
